// constants.js
export const SECTIONS = [
  {
    id: 1,
    image: require("../assets/main1.png"),
    text: "이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업",
    title: "이달의 ",
    highlight: "메이크업",

    animateOnScroll: true,
  },
  {
    id: 2,
    image: require("../assets/main2.png"),
    text: "이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업이달의 메이크업",
    title: "메이크업 ",
    highlight: "레슨",
    animateOnScroll: true,
  },
  {
    id: 3,
    image: require("../assets/main3.png"),
    text: "퍼스널컬러 퍼스널컬러 퍼스널컬러 퍼스널컬러 퍼스널컬러퍼스널컬러퍼스널컬러 ",
    title: "퍼스널 ",
    highlight: "컬러",
    animateOnScroll: true,
  },
  {
    id: 4,
    image: require("../assets/main4.png"),
    text: "퍼스널컬러 퍼스널컬러 퍼스널컬러 퍼스널컬러 퍼스널컬러퍼스널컬러퍼스널컬러 ",
    title: "이미지 ",
    highlight: "컨설팅",
    animateOnScroll: true,
  },
];
